(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["three-image-slider"] && !window.DesignMode) return;
  try {
    
let currentSlide = 0;
const track = document.getElementById('slider-track');
const totalSlides = track.children.length;

function autoSlide() {
  currentSlide = (currentSlide + 1) % totalSlides;
  track.style.transform = `translateX(-${currentSlide * 100}%)`;
}

setInterval(autoSlide, 3000);

  } catch(e) { console.error(e); }
})();
})();
